/* tslint:disable */

/**
 */
export class HistoryShiftForm {
    shifts?: number[];
}
